import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';



@Injectable({
  providedIn: 'root'
})
export class UserService {
  public Data = new BehaviorSubject(null)
  constructor(private _HttpClient:HttpClient) { }
  GetUser():Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/User/GetAllUsers`);
  }

  DeleteUser(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/User/Delete?id=${id}`);
  }

  CreateUser(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/User/Create`,data);
  }
  UpdateUser(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/User/Update`,data)
  }
}
